import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./UnsettledMealOrderList.css";

import { getUnsettledOrders } from "../../../../actions/mealOrderActions";

class UnsettledMealOrderList extends React.Component {
    componentDidMount() {
        this.props.getUnsettledOrders();
    }

    renderRows = () => this.props.unsettledOrdersList.map((row, index) => this.renderRow(row, index));

    renderRow = (row = null, index = null) => {
        return (
            <tr key={row ? index : "header"}>
                <td className={row ? "content" : "header"}>{row ? row.day : "Dzień"}</td>
                <td className={row ? "content" : "header"}>{row ? row.count : "Liczba zamówień"}</td>
            </tr>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="unsettled-meal-order-list-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="active item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-orders/unsettled" className="active item">
                                <div className="content">Nierozliczone zamówienia</div>
                            </Link>
                            <Link to="/meal-orders/reports" className="item">
                                <div className="content">Wygenerowane zestawienia</div>
                            </Link>
                            <Link to="/meal-orders/reports/new" className="item">
                                <div className="content">Nowe zestawienie</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.unsettledOrdersList.length ? (
                            <React.Fragment>
                                <div className="ui large header">
                                    <div className="content">Nierozliczone zamówienia:</div>
                                </div>
                                <table className="content">
                                    <tbody>
                                        {this.renderRow()}
                                        {this.renderRows()}
                                    </tbody>
                                </table>
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="check circle icon"></i>
                                        <div className="content">Rozliczono wszystkie zamówienia</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    unsettledOrdersList: state.mealOrder.unsettled
});

export default connect(mapStateToProps, { getUnsettledOrders })(UnsettledMealOrderList);